import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILDomains, SCDomains } from '@app-constants/app.constants';
import { TenantConstant } from '@app-constants/tenant.constant';
import { Observable } from 'rxjs';
import { ApiUrlConstant } from 'src/app/constants/api-url.constant';
import { RestApiService } from '../rest/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class SignupService extends RestApiService {

  apiUrl = ApiUrlConstant.apiUrl;
  branch: any = TenantConstant.branch;
  tenant: any = TenantConstant.tenant;

  generateOtp(obj: any, countryCode: string): Observable<any> {
    const url = this.apiUrl + `/api/authentication/generateOTP`;
    console.log(obj)
    const body: any = {
      "isdCode": countryCode,
      "phone": obj.phone,
      "whatsappConsent": obj.whatsappConsent
    };
    if (obj.firstName) {
      body.firstName = obj.firstName
    }
    if (obj.lastName) {
      body.lastName = obj.lastName
    }
    if (obj.gradeId) {
      body.gradeId = obj.gradeId
    }
    if (obj.admissionNumber) {
      body.admissionNumber = obj.admissionNumber
    }
    if (obj?.register) {
      var header = new HttpHeaders().set('X-Page', 'REGISTER_GENERATE').append('X-Platform','web').append('X-Product', '1' )
      console.log(header)
      return this.post(url, body, header);

    } else {
      return this.post(url, body);

    }

  }

  sendOtp(phone: any, countryCode: string): Observable<any> {
    const url = this.apiUrl + `/sms/${phone}`;
    return this.get<any>(url);
  }

  validatePhoneNumber(phone: any, otp: any): Observable<any> {
    const url = this.apiUrl + `/api/users/validate/${phone}/${otp}`;
    return this.get<any>(url);
  }

  validateOtp(inp): Observable<any> {
    let {countryCode, phone, otp, register, page = "WEB_IL_SITE", userActivityTrackingDataDto} = inp;
    const url = this.apiUrl + `/api/authentication/validateOTP?isBearerRequired=true`;
    const body: any =
    {
      "isdCode": countryCode,
      "phone": phone,
      "userOtp": otp,
      "userActivityTrackingDataDto": userActivityTrackingDataDto
    }
    if (register) {
      let header = new HttpHeaders().set('X-Page', 'REGISTER_VALIDATE'+"_"+page).append('X-Product', '1' )
      return this.post(url, body, header);

    } else {
      let header = {  
        "X-Page": userActivityTrackingDataDto?.data?.page || "WEB_IL_SITE",
        "X-Product": "1",
      }
      return this.post(url, body, header);

    }
  }

  getCountryCodes(): Observable<any> {
    const url = this.apiUrl + `/api/countrycodes`;
    return this.get<any>(url);
  }

  verifyPhoneNumber(obj: any): Observable<any> {
    const reqObj = {
      "isdCode": obj.dialCode,
      "phone": obj.number
    }
    const url = this.apiUrl + `/api/users/verifyPhone`;
    return this.post<any>(url, reqObj);
  }

  register(obj: any, regobj?): any {

    if(regobj?.register){
      var httpheaders = new HttpHeaders().set('X-Page', 'register').append('X-Platform','web').append('X-Product', '1' )
      const url = this.apiUrl + `/api/users`;
      return this.post<any>(url, obj, httpheaders);
    } else{
      const url = this.apiUrl + `/api/users`;
      return this.post(url, obj);
    }
  }

  // forgot password
  validateOtpForForgotPassword(isdCode: any, phone: any, otp: any): Observable<any> {
    const url = this.apiUrl + `/api/authentication/validateOTP`;
    const body: any =
    {
      "isdCode": isdCode,
      "phone": phone,
      "userOtp": otp
    }
    return this.post(url, body);
  }

  ILITEsheetLinks = {
    "NEET_9_10_13": 'https://sheetdb.io/api/v1/fufd7lbfcx8eg',
    "NEET_11_12": 'https://sheetdb.io/api/v1/b1r0l8qw04m6m',
    "JEEMAIN_9_10_13": 'https://sheetdb.io/api/v1/zg5ojcxgcfuky',//d
    "JEEMAIN_11_12": 'https://sheetdb.io/api/v1/bt4j392p0es6t',//d
    "JEEADVANCED_9_10_13": 'https://sheetdb.io/api/v1/eaxrpki868hq2',
    "JEEADVANCED_11_12": 'https://sheetdb.io/api/v1/oeub5h11g019m',
  };
      
  signupDataToGSheets(data: any, source: any = "Jee") {
    return fetch(this.ILITEsheetLinks[source], {
      method: 'POST', body: (data)
    })

    // var url = 'https://script.google.com/macros/s/AKfycby4G6URbBtizSUaoaxfiG2zdwjIF9li0VxqLdv4IvQWvOhJ5Dc/exec';
    // return this.post(url, data);
  }

  leadSquaredJee(data) {
    if (typeof data == 'object') {
      const domains = this.tenant == 'infinitylearn' ? ILDomains : SCDomains;
      data['product'] = domains[this.branch] ? domains[this.branch] : domains['production'];
    }

    console.log(data);
    return fetch("https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.Capture?accessKey=u$r068afce9a04b44cda9e5f1d39e13993f&secretKey=b6baaef22ef7f3269861306598fae53f02e053e9", {
      method: 'POST', headers: new Headers({ 'content-type': 'application/json' }), body: JSON.stringify(data)
    })
  }
  // var url = 'https://script.google.com/macros/s/AKfycby4G6URbBtizSUaoaxfiG2zdwjIF9li0VxqLdv4IvQWvOhJ5Dc/exec';
  // return this.post(url, data);

  generateOtpForUpdateNumber(userId: any, obj: any): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}/phone/generateOTP`;
    console.log(obj);
    return this.post(url, obj);
  }
}
